import RelatedTableV from "./RelatedTable";
import RelatedModalV from "./RelatedModal";
import { connect } from "react-redux";
import {actions} from "./logic/relatedFilmsFormActions";

export const RelatedTable = connect(
    ({relatedFilmsForm}) => (
        {
            open: relatedFilmsForm.open,
            values: relatedFilmsForm.values,
            editing: relatedFilmsForm.editing,
        }
    ),
    dispatch => {
        return {
            toggleRelatedFilmsForm: (editing,id) => dispatch(actions.TOGGLE_RELATED_FILM_FORM.send({editing,id})),
        };
    }
)( RelatedTableV);

export const RelatedModal = connect(
    ({relatedFilmsForm}) => (
        {
            addStatus: relatedFilmsForm.addStatus,
            editStatus: relatedFilmsForm.editStatus,
            editing: relatedFilmsForm.editing,
            initValues: relatedFilmsForm.values,
            open: relatedFilmsForm.open,
        }
    ),
    dispatch => {
        return {
            toggleRelatedFilmsForm: (editing,id) => dispatch(actions.TOGGLE_RELATED_FILM_FORM.send({editing,id})),
            onAdd: (values, callback) => dispatch(actions.ADD_RELATED_FILM.send({ values, callback })),
            onEdit: (values, callback) => dispatch(actions.EDIT_RELATED_FILM.send({ values, callback })),

        };
    }
)(RelatedModalV);

